export const sentenceCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const format = (str: string, ...args: string[]) => {
  if (!str) {
    return '';
  }

  return str.replaceAll(/{(\d+)}/g, (match, idx) => {
    return args[idx] === undefined ? '' : args[idx];
  });
};

export const pluralize = (count: number, singular: string, plural: string) => {
  return count === 1 ? singular : plural;
};

export const parseName = (name: string, emptyValue = '') => {
  if (!name) {
    return {
      firstName: emptyValue,
      lastName: emptyValue,
    };
  }

  const cleanedName = name.trim();
  const lastSpaceIdx = cleanedName.lastIndexOf(' ');

  if (lastSpaceIdx < 0) {
    return {
      firstName: cleanedName,
      lastName: emptyValue,
    };
  }

  const firstName = cleanedName.slice(0, Math.max(0, lastSpaceIdx));
  const lastName = cleanedName.slice(Math.max(0, lastSpaceIdx + 1));

  return {
    firstName,
    lastName,
  };
};

export const getNameParts = ({
  firstName,
  fullName,
  lastName,
}: {
  firstName?: string;
  fullName?: string;
  lastName?: string;
}) => {
  let resolvedFirstName = firstName;
  let resolvedLastName = lastName;

  if (fullName && (!resolvedFirstName || !resolvedLastName)) {
    const parsedName = parseName(fullName);

    resolvedFirstName = resolvedFirstName || parsedName.firstName;
    resolvedLastName = resolvedLastName || parsedName.lastName;
  }

  const resolvedFullName = [resolvedFirstName, resolvedLastName].filter(Boolean).join(' ');

  return {
    firstName: resolvedFirstName,
    fullName: resolvedFullName,
    lastName: resolvedLastName,
  };
};

export function numberFromPxValue(value?: string) {
  return value ? Number(value.replace('px', '')) : 0;
}

export const formatEventTime = (date: string) => {
  const eventDate = new Date(date);
  const timeString = eventDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: '2-digit',
    timeZone: 'UTC',
  });
  const offset = eventDate.getTimezoneOffset() / -60;
  const sign = offset > 0 ? '+' : '-';

  return `${timeString} UTC ${sign}${Math.abs(offset)}`;
};

export const formatShortDate = (date: string) => {
  const eventDate = new Date(date);

  return {
    day: eventDate.getDate(),
    month: eventDate.toLocaleString('en-US', { month: 'short' }),
  };
};

export const formatDuration = (duration?: null | number) => {
  if (!duration || duration <= 0) {
    return '';
  }

  const minutes = Math.floor(duration / 60);
  const seconds = `${Math.floor(duration) % 60}`.padStart(2, '0');

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
